/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Download_Csv_FileInputs */

const en_download_csv_file = /** @type {(inputs: Download_Csv_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download CSV file`)
};

const nl_download_csv_file = /** @type {(inputs: Download_Csv_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download CSV-bestand`)
};

/**
* | output |
* | --- |
* | "Download CSV file" |
*
* @param {Download_Csv_FileInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const download_csv_file = /** @type {((inputs?: Download_Csv_FileInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Download_Csv_FileInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_download_csv_file(inputs)
	return en_download_csv_file(inputs)
});